import React, { Fragment } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ItemBox from '../../../components/itens/item';


function ExpoMacucoAntScreen() {
    return (
        <Fragment>
            <Head titulo="Transparência da Expo Macuco em anos Anteriores" />
            <Header />
            <Container>
                <Row>
                    <Col xs={12}> <h2 style={{ textAlign: 'center' }}>Prestação de Contas da Expo Macuco em anos anteriores a 2023</h2>
                    </Col>
                </Row>
                <br />
                <br />
                <Fragment>
                  
                    <br />
                    <Row xs={12} lg={2}>
                        <Col>
                            <ItemBox
                                titulo={"Contratos Expo Macuco em anos anteriores"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de contratos firmados por essa prefeitura para realização da Exposição Agropecuária de Macuco em anos anteriores.</p><br /></Fragment>}
                                awesome={"faFileSignature"}
                                link={"../contratos/expomacuco/anteriores"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Licitações/Dispensas Expo Macuco em anos anteriores"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de licitações e dispensas realizadas por essa prefeitura para realização da Exposição Agropecuária de Macuco em anos anteriores.</p><br /></Fragment>}
                                awesome={"faStore"}
                                link={"../licitacao/expomacuco/anteriores"}
                            />
                        </Col>
                        <Col>
                            <ItemBox
                                titulo={"Legislação da Expo Macuco em anos anteriores"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de leis e decretos publicados por essa prefeitura para realização da Exposição Agropecuária de Macuco em anos anteriores.</p><br /></Fragment>}
                                awesome={"faScaleBalanced"}
                                link={"../diario/expomacuco/anteriores"}
                            />
                        </Col>
                        {/*<Col>
                            <ItemBox
                                titulo={"Outras publicações Expo Macuco em anos anteriores"}
                                descricao={<Fragment><p>Clique aqui e veja a listagem de outras publicações feitas por essa prefeitura a respeito da Exposição Agropecuária de Macuco em anos anteriores.</p><br /></Fragment>}
                                awesome={"faBullhorn"}
                                link={"../expomacuco/anteriores/publicacoes"}
                            />
                        </Col>*/}
                        <br />
                    </Row>
                    <Row xs={1}>
                        <Col xs={{ span: 2, offset: 11 }}>
                            <Link to='/expomacuco'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </Fragment>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ExpoMacucoAntScreen;